import { GET_NOTICE_MACRO, LIST_NOTICE_MACRO } from '../actions/types';

const initialState = {
  noticeMacro: null,
  noticeMacros: {
    count: 0,
    rows: [],
  },
};

const noticeMacros = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTICE_MACRO:
      return {
        ...state,
        noticeMacro: action.payload,
        // messageMacros: initialState.messageMacros,
      };
    case LIST_NOTICE_MACRO:
      return {
        ...state,
        // messageMacro: initialState.messageMacro,
        noticeMacros: action.payload,
      };
    default:
      return state;
  }
};

export default noticeMacros;
